import React, {useContext} from 'react';
import PropTypes from 'prop-types';
import {useMedia} from "../../hooks/useMedia";
import {mediaFromM} from "../../helpers/media-queries";
import {TableTemplateContext} from "../../contexts/contexts";

const TableRow = props => {
  const {children} = props
  const fromM = useMedia(mediaFromM)
  const {heads} = useContext(TableTemplateContext)

  return (
    <tr>
      {fromM ? (
        children.map((_, i) => (
          <td>{children[i]}</td>
        ))
      ) : (
        <td>
          <div className="s-column s-flex-gap-12px">
            {children.map((_, i) => (
              <div className={`flex row-${i}`}>
                <p className="s-mb-0 s-color-lighter-text s-mr-4px">{heads[i]} : </p>
                {children[i]}
              </div>
            ))}
          </div>
        </td>
      )}
    </tr>
  );
};

TableRow.propTypes = {
  children: PropTypes.node.isRequired,
};

export default TableRow;
